export default (url,data,callback)=>{
		data.appid = APP_ID;
		let controller = new AbortController();
		let options = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'h5token':localStorage.getItem('token')
			},
			signal: controller.signal,
			body: JSON.stringify(data)
		}
		fetch(API_SERVER + url, options).then(response => response.body)
		.then(body => {
			const reader = body.getReader();
			const decoder = new TextDecoder('utf-8');
			let startFlag = true;
			return new ReadableStream({
				start(controller) {
					return pump();
					function pump() {
						return reader.read().then(({ done, value }) => {
							// 读不到更多数据就关闭流
							if (done) {
								controller.close();
								if(startFlag){
									callback("请重新提问",startFlag);
									if(startFlag) startFlag = false
								}
								callback("#end#");
								return;
							}
							// 将下一个数据块置入流中
							callback(decoder.decode(value, { stream: true }),startFlag);
							if(startFlag) startFlag = false
							return pump();
						});
					}
				}
			})
		})
		controller.signal.addEventListener('abort',
		  () => console.log('abort!')
		);
		return controller;
	}
